import React from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';

// Import components
import SchoolDashboard from '../components/schools/SchoolDashboard';
import TeacherManagement from '../components/schools/TeacherManagement';
import ClassManagement from '../components/schools/ClassManagement';
import StudentManagement from '../components/schools/StudentManagement';
import SchoolAnalytics from '../components/schools/SchoolAnalytics';
import SchoolMessaging from '../components/schools/SchoolMessaging';
import EcommerceManagement from '../components/schools/EcommerceManagement';
import OrderManagement from '../components/schools/OrderManagement';
import ShopPreview from '../components/schools/ShopPreview';
import SchoolWhatsappIntegration from '../components/schools/SchoolWhatsappIntegration';
import SchoolBilling from '../components/schools/SchoolBilling';
import SchoolProfile from '../components/schools/SchoolProfile';
import SchoolSettings from '../components/schools/SchoolSettings';
import DomainSettings from '../components/schools/DomainSettings';
import SchoolDiscountCodes from '../components/schools/SchoolDiscountCodes';
import SubscriptionPage from '../components/dashboard/SubscriptionPage';
import Checkout from '../pages/dashboard/Checkout';
import NotFound from '../pages/public/NotFound';

/**
 * Nested routes configuration for the school panel
 */
const SchoolRoutes = () => {
  return (
    <Routes>
      <Route path="/" element={<SchoolDashboard />} />
      <Route path="/dashboard" element={<Navigate to="/school" replace />} />
      <Route path="/teachers" element={<TeacherManagement />} />
      <Route path="/classes" element={<ClassManagement />} />
      <Route path="/students" element={<StudentManagement />} />
      <Route path="/reports" element={<SchoolAnalytics />} />
      <Route path="/messages" element={<SchoolMessaging />} />
      
      {/* Ecommerce routes */}
      {/* These routes allow school admins to manage products, orders, and view their online shop */}
      <Route path="/ecommerce" element={<EcommerceManagement />} />
      <Route path="/ecommerce/orders" element={<OrderManagement />} />
      <Route path="/ecommerce/discounts" element={<SchoolDiscountCodes />} />
      <Route path="/ecommerce/preview" element={<ShopPreview />} />
      
      {/* Integration routes */}
      <Route path="/whatsapp" element={<SchoolWhatsappIntegration />} />
      <Route path="/domains" element={<DomainSettings />} />
      
      <Route path="/billing" element={<SchoolBilling />} />
      <Route path="/profile" element={<SchoolProfile />} />
      <Route path="/settings" element={<SchoolSettings />} />
      <Route path="/subscription" element={<SubscriptionPage userType="school" />} />
      <Route path="/checkout" element={<Checkout />} />
      {/* Add other school-specific routes here */}
      <Route path="*" element={<NotFound />} />
    </Routes>
  );
};

export default SchoolRoutes; 